import React from 'react';
import { XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { painPoints } from '../data/content';
export function Pain() {
  return <section className="w-full bg-cream" data-id="element-101" data-mp="1j0wrhg7iolw8">
      <div className="mx-auto w-full max-w-5xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-102" data-mp="1izv7uncfqr2w">
        <SectionLabel data-id="element-103" data-mp="1e23bnh4rcisw">Lo que suele pasar</SectionLabel>
        <h2 className="max-w-2xl font-display text-[1.6rem] leading-tight text-ink sm:text-4xl" data-id="element-104" data-mp="1a1jieonb1zc1">
          El problema es que aprender sola puede ser frustrante
        </h2>

        <ul className="mt-8 grid gap-3 sm:mt-10 sm:gap-4 sm:grid-cols-2" data-id="element-105" data-mp="158gogfem8nvb">
          {painPoints.map((point, index) => <motion.li key={point} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.07
        }} className="flex items-start gap-3 rounded-2xl border border-ink/10 bg-white/50 p-4 sm:gap-4 sm:p-5" data-id="element-106" data-mp="vcnbiuwzisd0" data-mpi={index}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-clay/12 text-clay" data-id="element-107" data-mp="23nq2rhvird6j">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="1p04w5dzfqvtv" />
              </span>
              <span className="font-sans text-[15px] leading-relaxed text-ink/75 sm:text-base" data-id="element-109" data-mp="1txevblcmmluw">
                {point}
              </span>
            </motion.li>)}
        </ul>

        <p className="mt-8 max-w-2xl font-display text-lg leading-relaxed text-ink/85 sm:mt-10 sm:text-2xl" data-id="element-110" data-mp="2mndpfv5oh96f">
          Hacer jabones es un arte, pero requiere un método. Si no tenés la guía
          correcta, vas a desperdiciar materiales caros y mucho tiempo.
        </p>
      </div>
    </section>;
}